import { FC } from "react";
import { useSearchParams } from "react-router-dom";
import useI18n from "../../../../hooks/useTranslations";
import Tabs, { Tab } from "../../../ui/Tabs";
import Handles from "./Handles";
import InstallationTypes from "./installationTypes/InstallationTypes";
import Normatives from "./normatives/Normatives";
import SteelVersions from "./steelVersions/SteelVersions";
import SystemTypes from "./systemTypes/SystemTypes";
import Texts from "./texts/Texts";

const VertigripSettings: FC = () => {
  const tabParam = "tab";
  const i18n = useI18n();
  const [searchParams] = useSearchParams();
  const selectedIndex = Number(searchParams.get(tabParam)) || 0;

  const tabs: Tab[] = [
    { title: i18n.translation.normatives.plural },
    { title: i18n.translation.handles.plural },

    { title: i18n.translation.installationTypes.plural },
    { title: i18n.translation.steelVersions.plural },
    { title: i18n.translation.systemTypes.plural },

    { title: i18n.translation.texts.plural },
  ];

  return (
    <Tabs
      urlParameter={tabParam}
      tabs={tabs}
      contents={[
        <Normatives active={selectedIndex === 0} />,
        <Handles active={selectedIndex === 1} />,
        <InstallationTypes active={selectedIndex === 2} />,
        <SteelVersions active={selectedIndex === 3} />,
        <SystemTypes active={selectedIndex === 4} />,
        <Texts active={selectedIndex === 5} />,
      ]}
    />
  );
};

export default VertigripSettings;
